<template>
  <v-row dense>
    <v-col>
      <v-card flat>
        <v-card-text class="px-3 pt-2 pb-1">
          <DataListHeading
            label="Дані обміну"
            :search-field="false"
            :loading="loading"
            :divider="false"
            disabled
          />
          <v-row v-for="entry in entries" :key="entry.id">
            <v-col>
              {{ entry.id }}
            </v-col>
            <v-col>
              {{ entry.dataType }}
            </v-col>
            <v-col>
              {{ entry.updatedAt }}
            </v-col>
            <v-col>
              {{ entry.data }}
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import DataListHeading from "@/components/DataListHeading.vue";
import * as exchangeEntriesApi from "../backend/exchange-entries-api";

export default {
  components: {
    DataListHeading,
  },
  async created() {
    this.loading = true;
    this.entries = await exchangeEntriesApi.getExchangeEntries();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      entries: [],
    };
  },
};
</script>